/** 비교 카드가 켜고 끄는 정보 블록, 그리고 조회 크기. */

import { PRODUCT_TAG_FILTER_GROUPS } from 'src/constants/product-search-options';

/** 한 채널에서 받아 오는 랭킹 개수 */
export const PER_SOURCE = 100;
/** 랭킹 인덱스 검색 결과 개수 */
export const SEARCH_LIMIT = 60;

/** ⚠️ 배열 순서가 곧 카드에 그려지는 순서다 */
export const SECTION_OPTIONS = [
  { key: 'metrics', label: '요약 지표' },
  { key: 'signals', label: '변동 신호' },
  { key: 'tags', label: '상품 태그' },
  { key: 'trend', label: '순위·가격 변동' },
  { key: 'cross', label: '타 판매채널 랭킹' },
  { key: 'review', label: '리뷰·반응' },
  { key: 'spec', label: '상품 정보' },
  { key: 'media', label: '상세페이지' },
];

export const ALL_SECTION_KEYS = SECTION_OPTIONS.map((option) => option.key);

/** 상세페이지 AI 태그 축 — 정본은 `src/constants/product-search-options` */
export const TAG_FILTER_GROUPS = PRODUCT_TAG_FILTER_GROUPS;

/**
 * 카드에 태그를 **그릴 때** 쓰는 짝.
 *
 * ⚠️ `key`는 응답(`ProductDetailTags`)의 필드명이고 `param`은 검색에 넘기는 이름이라
 * **둘이 다르다**(`targetArea` ↔ `area`, `concerns` ↔ `concern`, `ingredients` ↔
 * `ingredient`). 위 `TAG_FILTER_GROUPS`와 `param`이 어긋나면 태그를 눌러도 그 태그로
 * 안 걸린다 — 두 배열의 `param`은 항상 같은 말이어야 한다.
 */
export const TAG_GROUPS = [
  { key: 'productType', param: 'productType', label: '유형', color: 'primary' },
  { key: 'form', param: 'form', label: '제형', color: 'primary' },
  { key: 'targetArea', param: 'area', label: '부위', color: 'info' },
  { key: 'concerns', param: 'concern', label: '고민', color: 'success' },
  { key: 'ingredients', param: 'ingredient', label: '핵심 성분', color: 'warning' },
] as const;
